$(document).on("click", ".grid-product__colors .color-swatch", function () {
  $(this)
    .parents(".grid-product__colors")
    .find(".active-swatch")
    .removeClass("active-swatch");
  $(this).addClass("active-swatch");

  var json_data = JSON.parse(
    $(this).parents(".grid-product").find("[data-selected-variant]").text()
  );
  var color_value = $(this).parents(".grid-product").find(".active-swatch").data('value');
  var sizes = $(this).parents(".grid-product").find(".product-option li");
  var selected_values = [];

  for (let i = 0; i < json_data.length; i++) {
    if((json_data[i].title).includes(color_value)){
      selected_values.push(json_data[i]);
    }
  }

  for (let i = 0; i < selected_values.length; i++) {
    for (let j = 0; j < sizes.length; j++) {
      // console.log($(sizes[j]).data('value'));
      if(selected_values[i].options[0] == $(sizes[j]).data('value') || selected_values[i].options[1] == $(sizes[j]).data('value')){
        if(!selected_values[i].available){
          $(sizes[i]).addClass('disabled');
        }
        break;
      }
    }
  }
});

$(document).on("click", ".product-options-item", function () {
  var size_value = $(this).data('value');
  var color_value = $(this).parents(".grid-product").find(".active-swatch").data('value');
  var json_data = JSON.parse(
    $(this).parents(".grid-product").find("[data-selected-variant]").text()
  );
  var values = [];

  values.push(size_value);
  values.push(color_value);

  var compare = false;
  var selected = "";

  for (let i = 0; i < json_data.length; i++) {
    for (let j = 0; j < values.length; j++) {
      if (json_data[i].options[j] == values[j]) {
        compare = true;
        selected = json_data[i];
      } else {
        compare = false;
        break;
      }
    }
    if (compare) {
      break;
    }
  }

  if (selected.available) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: selected.id
      },
      dataType: 'json', 
      success: function (data) {
        document.dispatchEvent(new Event('ajaxProduct:added'));
        document.dispatchEvent(new Event('cart:open'));
      } 
    });
  } else {
    // alert('Product is unavailable')
  }
});

// var check = false;
// var handles = [];
// var myInterval = setInterval(function () {
//     if($('.variable-products-list .grid-product.variable-products').length > 0){
//       setTimeout(function() {
//         for (let i = 0; i < $('.variable-products-list .grid-product.variable-products').length; i++) {
//           var color_name = $($('.variable-products-list .grid-product.variable-products')[i]).data('b4b-color');
          
//           $($('.variable-products-list .grid-product.variable-products')[i]).find('.grid-product__colors .color-swatch[data-value="'+color_name+'"]').click()
          
//           // var handle = $($('.variable-products-list .grid-product.variable-products')[i]).data('product-handle');
//           // debugger
//           // if(!handles.includes(handle)){
//           //   var sub_products = $('.variable-products-list .grid-product.variable-products[data-product-handle="'+handle+'"]');
//           //   for (let j = 0; j < sub_products.length; j++) {
//           //     var color_name = $(sub_products[j]).data('b4b-color');
//           //     debugger
//           //     $(sub_products[j]).find('.grid-product__colors .color-swatch[data-value="'+color_name+'"]').click()
//           //   }
//           // }
//           // handles.push(handle);
//         }
//         check = true;
//       }, 1000);
//     }
//     if(check){
//       clearInterval(myInterval);
//     }
//   }, 3000);




let check = false;

function triggerColorSwatches() {
  if ($('.variable-products-list .grid-product.variable-products').length > 0) {
    $('.variable-products-list .grid-product.variable-products').each(function() {
      var $gridItem = $(this);
      var color_name = $gridItem.data('b4b-color');

      if (color_name) {
        var $swatch = $gridItem.find('.grid-product__colors .color-swatch[data-value="' + color_name + '"]');

        if ($swatch.length) {
          $swatch.trigger('click');

          // Check if all size options are disabled
          var allDisabled = true;
          $gridItem.find('.variant-inner-data .product-options-item').each(function() {
            if (!$(this).hasClass('disabled')) {
              allDisabled = false;
               // exit loop early if one is enabled
            }
          });

          if (allDisabled) {
            $gridItem.find('.grid-product__tag.grid-product__tag--sold-out').addClass('hide_it');
          }
        }
      }
    });

    check = true;
  }

  if (check) {
    clearInterval(myInterval);
  }
}

var myInterval = setInterval(triggerColorSwatches, 1000);


// Also trigger on DOM Ready (onload equivalent)
$(document).ready(function() {

 

  function triggerSwatchAndCheckSizes() {
    $('.variable-products-list .grid-product.variable-products').each(function() {
      var $gridItem = $(this);
      var color_name = $gridItem.data('b4b-color');

      if (color_name) {
        var $swatch = $gridItem.find('.grid-product__colors .color-swatch[data-value="' + color_name + '"]');

        if ($swatch.length) {
          $swatch.trigger('click');

          // Immediately check if all sizes are disabled
          var allDisabled = true;
          $gridItem.find('.variant-inner-data .product-options-item').each(function() {
            if (!$(this).hasClass('disabled')) {
              allDisabled = false;
              // exit each loop early
            }
          });

          if (allDisabled) {
            $gridItem.find('.grid-product__tag.grid-product__tag--sold-out').addClass('hide_it');
          }
        }
      }
    });
  }

  // Run the function multiple times after load
  setTimeout(triggerSwatchAndCheckSizes, 2000);
  setTimeout(triggerSwatchAndCheckSizes, 3000);
  setTimeout(triggerSwatchAndCheckSizes, 5000);
  setTimeout(triggerSwatchAndCheckSizes, 7000);
  setTimeout(triggerSwatchAndCheckSizes, 10000);




});
